export enum BetslipNotificationMessageType {
    NotSet = 0,
    Simple = 1,
    Extended = 2,
    Overask = 3,
    BetBuilder = 4,
}

export interface IBetslipNotificationState {
    messageType: BetslipNotificationMessageType;
    title: string;
    message: string;
}

export const defaultNotificationState: IBetslipNotificationState = {
    messageType: BetslipNotificationMessageType.NotSet,
    title: '',
    message: '',
};
